(() => {
  const STORAGE_KEY = 'gpuelite_compare_v1';
  const MAX_PRODUCTS = 4;
  const HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]*$/;
  const familyRows = {
    gpu: [
      ['GPU chipset','gpu_chipset'],['Architecture','architecture'],['Video memory','vram'],['Memory type','memory_type'],['PCIe interface','pcie'],['Recommended PSU','recommended_psu'],['Power connector','power_connector'],['Slot width','slot_width'],['Dimensions / length','dimensions'],['Cooling','cooling'],['Display outputs','display_outputs']
    ],
    system: [
      ['CPU','cpu'],['GPU','gpu'],['Memory','ram'],['Storage','storage'],['Display','display'],['Operating system','operating_system'],['Condition','condition']
    ],
    memory: [
      ['Capacity','capacity'],['Kit configuration','kit_configuration'],['Memory type','memory_type'],['Speed','speed'],['Latency','latency'],['Voltage','voltage']
    ],
    storage: [
      ['Capacity','capacity'],['Form factor','form_factor'],['Interface','interface'],['Read speed','read_speed'],['Write speed','write_speed'],['Endurance','endurance']
    ]
  };

  const readSelection = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && HANDLE_PATTERN.test(item.handle)).slice(0, MAX_PRODUCTS) : [];
    } catch (_) { return []; }
  };
  const writeSelection = (items) => {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_PRODUCTS))); }
    catch (_) { /* Comparison still works for this page view when storage is unavailable. */ }
  };
  const uniqueHandles = (value) => {
    const seen = new Set();
    return String(value || '').split(',').map((item) => item.trim()).filter((handle) => HANDLE_PATTERN.test(handle) && !seen.has(handle) && seen.add(handle)).slice(0, MAX_PRODUCTS);
  };
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  const initCardSelection = () => {
    const toggles = [...document.querySelectorAll('[data-compare-toggle]')];
    if (!toggles.length) return;
    let selection = readSelection();
    const tray = make('aside', 'electro-compare-tray');
    tray.dataset.compareTray = '';
    tray.setAttribute('aria-label', 'Product comparison selection');
    tray.hidden = true;
    const summary = make('div', 'electro-compare-tray__summary');
    const heading = make('strong', '', 'Compare products');
    const items = make('div', 'electro-compare-tray__items');
    const actions = make('div', 'electro-compare-tray__actions');
    const clear = make('button', 'electro-compare-tray__clear', 'Clear');
    clear.type = 'button';
    const status = make('p', 'visually-hidden');
    status.dataset.compareStatus = '';
    status.setAttribute('aria-live', 'polite');
    summary.append(heading, items, status);
    tray.append(summary, actions);
    document.body.append(tray);

    const announce = (message) => { status.textContent = ''; requestAnimationFrame(() => { status.textContent = message; }); };
    const sync = () => {
      writeSelection(selection);
      const selected = new Set(selection.map((item) => item.handle));
      toggles.forEach((button) => {
        const active = selected.has(button.dataset.compareHandle);
        button.setAttribute('aria-pressed', String(active));
        button.innerHTML = active ? '<span aria-hidden="true">✓</span> Selected' : '<span aria-hidden="true">+</span> Compare';
        const title = button.closest('[data-product-card]')?.querySelector('[data-card-title]')?.textContent?.trim() || button.dataset.compareTitle || 'product';
        button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${title} ${active ? 'from' : 'to'} comparison`);
      });
      tray.hidden = selection.length === 0;
      heading.textContent = `${selection.length} of ${MAX_PRODUCTS} selected`;
      items.replaceChildren();
      selection.forEach((item, index) => {
        const chip = make('div', 'electro-compare-tray__item');
        const order = make('b', 'electro-compare-tray__order', String(index + 1));
        const label = make('span', '', item.title || item.handle);
        const remove = make('button', '', '×');
        remove.type = 'button'; remove.dataset.compareTrayRemove = item.handle; remove.setAttribute('aria-label', `Remove ${item.title || item.handle} from comparison`);
        chip.append(order, label, remove); items.append(chip);
      });
      actions.replaceChildren(clear);
      if (selection.length >= 2) {
        const link = make('a', 'r4-btn r4-btn--primary', `Compare ${selection.length} products`);
        link.href = `/collections/all?view=compare&products=${selection.map((item) => encodeURIComponent(item.handle)).join(',')}`;
        link.dataset.compareGo = '';
        actions.prepend(link);
      } else {
        const disabled = make('button', 'r4-btn r4-btn--primary', 'Select one more');
        disabled.type = 'button'; disabled.disabled = true; disabled.dataset.compareGo = '';
        actions.prepend(disabled);
      }
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-compare-toggle]');
      if (toggle) {
        const handle = toggle.dataset.compareHandle;
        const existing = selection.findIndex((item) => item.handle === handle);
        if (existing >= 0) {
          const [removed] = selection.splice(existing, 1); announce(`${removed.title || handle} removed from comparison.`);
        } else if (selection.length >= MAX_PRODUCTS) {
          announce('Comparison supports up to four products. Remove one before adding another.');
          return;
        } else {
          const card = toggle.closest('[data-product-card]');
          const title = card?.querySelector('[data-card-title]')?.textContent?.trim() || toggle.dataset.compareTitle || handle;
          selection.push({handle, title}); announce(`${title} added as comparison item ${selection.length}.`);
        }
        sync();
      }
      const remove = event.target.closest('[data-compare-tray-remove]');
      if (remove) { selection = selection.filter((item) => item.handle !== remove.dataset.compareTrayRemove); sync(); announce('Product removed from comparison.'); }
    });
    clear.addEventListener('click', () => { selection = []; sync(); announce('Comparison selection cleared.'); });
    sync();
  };

  const initComparePage = () => {
    const root = document.querySelector('[data-electro-compare-page]');
    if (!root) return;
    const loading = root.querySelector('[data-compare-loading]');
    const setup = root.querySelector('[data-compare-setup]');
    const viewport = root.querySelector('[data-compare-viewport]');
    const table = root.querySelector('[data-compare-table]');
    const status = root.querySelector('[data-compare-page-status]');
    const share = root.querySelector('[data-compare-share]');
    const clear = root.querySelector('[data-compare-clear]');
    const dataView = root.dataset.compareDataView || 'compare-data';
    let renderToken = 0;
    const announce = (message) => { status.textContent = ''; requestAnimationFrame(() => { status.textContent = message; }); };
    const handlesFromURL = () => uniqueHandles(new URL(location.href).searchParams.get('products'));
    const updateURL = (handles) => {
      const url = new URL(location.href);
      if (handles.length) url.searchParams.set('products', handles.join(',')); else url.searchParams.delete('products');
      history.pushState({compare: handles}, '', url);
      render();
    };
    const groupFor = (family) => family === 'laptop' || family === 'desktop' ? 'system' : family;
    const valueFor = (product, key) => {
      if (key === 'manufacturer') return product.specs?.manufacturer;
      if (key === 'sku') return product.sku;
      if (key === 'price') return product.price;
      if (key === 'availability') return product.available ? 'In stock' : 'Out of stock';
      return product.specs?.[key];
    };
    const addCell = (row, className, text, role = 'cell') => {
      const cell = make('div', `electro-compare-page__cell ${className || ''}`.trim());
      cell.setAttribute('role', role);
      const value = String(text || '').trim();
      cell.textContent = value || 'Not provided';
      if (!value) cell.classList.add('electro-compare-page__value--missing');
      row.append(cell);
    };
    const renderTable = (products) => {
      table.replaceChildren();
      table.style.setProperty('--compare-count', products.length);
      table.setAttribute('role', 'table');
      table.setAttribute('aria-label', 'Selected product comparison');
      table.setAttribute('aria-colcount', String(products.length + 1));
      const groups = products.map((product) => groupFor(product.family));
      const technicalRows = groups.every((group) => group === groups[0]) ? (familyRows[groups[0]] || []) : [];
      const rows = [['Manufacturer','manufacturer'],['SKU','sku'],...technicalRows,['Price','price'],['Availability','availability']];
      table.setAttribute('aria-rowcount', String(rows.length + 1));
      const headerRow = make('div', 'electro-compare-page__row');
      headerRow.setAttribute('role', 'row');
      const spacer = make('div', 'electro-compare-page__cell electro-compare-page__product-spacer', 'Product'); spacer.setAttribute('role', 'columnheader'); headerRow.append(spacer);
      products.forEach((product, index) => {
        const card = make('article', 'electro-compare-page__cell electro-compare-page__product');
        card.setAttribute('role', 'columnheader');
        card.dataset.compareProduct = product.handle; card.dataset.compareOrder = String(index + 1);
        card.append(make('span','electro-compare-page__product-order',`Item ${index + 1}`));
        if (product.image) { const image = new Image(); image.src = product.image; image.alt = product.image_alt || product.title; card.append(image); }
        else card.append(make('div','electro-compare-page__image-placeholder','Image unavailable'));
        card.append(make('h2','',product.title));
        card.append(make('p','',product.sku ? `SKU ${product.sku}` : 'SKU not provided'));
        const productActions = make('div','electro-compare-page__product-actions');
        const link = make('a','r4-btn r4-btn--primary','View product'); link.href = product.url;
        const remove = make('button','electro-compare-page__remove','×'); remove.type='button'; remove.dataset.comparePageRemove=product.handle; remove.setAttribute('aria-label',`Remove ${product.title} from comparison`);
        productActions.append(link,remove);card.append(productActions);headerRow.append(card);
      });
      table.append(headerRow);
      rows.forEach(([label,key]) => {
        const row = make('div', 'electro-compare-page__row');
        row.setAttribute('role', 'row');
        addCell(row, 'electro-compare-page__label', label, 'rowheader');
        products.forEach((product) => addCell(row, '', valueFor(product,key)));
        table.append(row);
      });
      viewport.hidden = false; setup.hidden = true; loading.hidden = true;
    };
    const render = async () => {
      const token = ++renderToken; const handles = handlesFromURL();
      viewport.hidden = true; table.replaceChildren();
      if (handles.length < 2) { loading.hidden = true; setup.hidden = false; announce('Select at least two products to compare.'); return; }
      setup.hidden = true; loading.hidden = false;
      try {
        const products = await Promise.all(handles.map(async (handle) => {
          const response = await fetch(`/products/${encodeURIComponent(handle)}?view=${encodeURIComponent(dataView)}`, {credentials:'same-origin'});
          if (!response.ok) throw new Error(`Unable to load ${handle}`);
          const data = await response.json();
          if (data.handle !== handle) throw new Error(`Product identity mismatch for ${handle}`);
          return data;
        }));
        if (token !== renderToken) return;
        renderTable(products);
        writeSelection(products.map((product) => ({handle:product.handle,title:product.title})));
        announce(`${products.length} products loaded in selected order.`);
      } catch (error) {
        if (token !== renderToken) return;
        loading.hidden = true; setup.hidden = false; setup.querySelector('h2').textContent = 'Comparison data could not be loaded.'; setup.querySelector('p:not(.r4-eyebrow)').textContent = error.message; announce(error.message);
      }
    };
    root.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-compare-page-remove]');
      if (remove) updateURL(handlesFromURL().filter((handle) => handle !== remove.dataset.comparePageRemove));
    });
    clear.addEventListener('click', () => updateURL([]));
    share.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(location.href); announce('Comparison link copied.'); }
      catch (_) { announce('Comparison URL is ready in the browser address bar.'); }
    });
    addEventListener('popstate', render);
    render();
  };

  const init = () => { initCardSelection(); initComparePage(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
